export const PARSING_RULES_RESET_STATE = 'PARSING_RULES_RESET_STATE';
export const PARSING_RULES_CURRENT_ITEM = 'PARSING_RULES_CURRENT_ITEM';

export const PARSING_RULES_REQUEST_LOADING = 'PARSING_RULES_REQUEST_LOADING';
export const PARSING_RULES_REQUEST_SUCCESS = 'PARSING_RULES_REQUEST_SUCCESS';
export const PARSING_RULES_REQUEST_FAILED = 'PARSING_RULES_REQUEST_FAILED';

export const PARSING_RULES_CURRENT_ACTION = 'PARSING_RULES_CURRENT_ACTION';
export const PARSING_RULES_RESET_ACTION = 'PARSING_RULES_RESET_ACTION';